export const InterestBox = ({ deal, pos, busy, onInterest }) => {
  if (!(deal.status === "open" && !deal.my_commitment)) return null;
  return (
    <div className="mt-6 p-4" style={{ background: "#14171A", border: "1px solid #24272B" }} data-testid="member-interest-box">
      <span className="t-label">Your interest</span>
      {pos?.response === "interested" ? (
        <>
          <p className="t-small text-bone mt-1" data-testid="member-interest-position">You are number {pos.position} of {pos.total_interested} interested. We generally allocate in the order interest was registered.</p>
          <button className="btn-ghost mt-3 !py-2" disabled={busy} onClick={() => onInterest("pass")} data-testid="member-pass-button">Pass this one</button>
        </>
      ) : pos?.response === "pass" ? (
        <>
          <p className="t-small text-muted-s mt-1">You passed on this one. Change your mind and you will rejoin at the back of the line.</p>
          <button className="btn-primary mt-3 !py-2" disabled={busy} onClick={() => onInterest("interested")} data-testid="member-interested-button">I am interested</button>
        </>
      ) : (
        <>
          <p className="t-small text-muted-s mt-1">Register your interest so we know to weight you when we allocate.</p>
          <div className="flex gap-3 mt-3">
            <button className="btn-primary !py-2" disabled={busy} onClick={() => onInterest("interested")} data-testid="member-interested-button">I am interested</button>
            <button className="btn-ghost !py-2" disabled={busy} onClick={() => onInterest("pass")} data-testid="member-pass-button">Pass</button>
          </div>
        </>
      )}
    </div>
  );
};
